module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('vue-slider', {
    ref: "slider",
    class: _vm.serviceAnswerDetail.point > 0 ? 'answered-slider' : 'no-answer-slider',
    attrs: {
      "dotSize": "24",
      "height": "8px",
      "enable-cross": false,
      "interval": 1,
      "min": 0,
      "data": _vm.data(_vm.serviceAnswerDetail.attributes['max-point']),
      "max": Number(_vm.serviceAnswerDetail.attributes['max-point']),
      "marks": true
    },
    on: {
      "change": function($event) {
        _vm.handleChange($event)
      }
    },
    model: {
      value: (_vm.serviceAnswerDetail.point),
      callback: function($$v) {
        _vm.$set(_vm.serviceAnswerDetail, "point", $$v)
      },
      expression: "serviceAnswerDetail.point"
    }
  })], 1), _c('div', {
    staticClass: "col-xs-3"
  }, [(!_vm.serviceAnswerDetail.point) ? _c('p', {
    staticClass: "no-answer-warning"
  }, [_vm._v("未回答")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06742d9e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceAnswerEditSlider.vue
// module id = 1369
// module chunks = 1